import httpClient from './httpClient';
import { saveStorage } from './storageSave';
const blankForm = {
    formOne: {
        hiringManagerName: '',
        hiringManagerEmail: '',
        employeeName: '',
        employeeEmail: '',
        saved: false,
    },
    formTwo: {
        recruitmentReason: '',
        inBudget: '',
        saved: false,
    },
    formThree: {
        jobTitle: '',
        numberOfPositions: '',
        roleLocationSite: '',
        roleLocationPostcode: '',
        employeeType: '',
        employmentContract: '',
        saved: false,
    },
    formFour: {
        businesscontact: null,
        employedin: '',
        division: '',
        assigned: '',
        saved: false,
    },
    formFive: {
        hoursPerWeek: '',
        weeksPerYear: '',
        shiftPattern: [],
        additionalInformation: '',
        saved: false,
    },
    formSix: {
        contractType: '',
        contractLevel: '',
        salaryBasis: '',
        minimumPayRate: '',
        minimumPayRateCurrency: 'GBP',
        maximumPayRate: '',
        maximumPayRateCurrency: 'GBP',
        additionalAllowances: '',
        additionalAllowancesInformation: [
            {
                additionalAllowancesTitle: '',
                additionalAllowancesInformation: '',
            },
        ],
        payrollFrequency: '',
        saved: false,
    },
    formSeven: {
        recruitmentTeam: '',
        advertise: 'selected',
        channels: [],
        channelsOther: '',
        recruitmentShortlist: '',
        saved: false,
    },
    formEight: {
        discloseCheckRequired: '',
        disclosureSchemeEnglandWales: '',
        disclosureSchemeScotland: '',
        childSafeguardingRequired: '',
        saved: false,
    },
    formNine: {
        securityRole: '',
        securitySIA: '',
        securityCheck: '',
        securityPreliminary: '',
        securityBSVR: '',
        securityGovernment: '',
        securityDWP: '',
        securityMobile: '',
        securityBefore: '',
        saved: false,
    },
    formTen: {
        highwayWorker: '',
        mobileWorker: '',
        hybridWorker: '',
        collectiveBargaining: '',
        collectiveBargainingText: '',
        saved: false,
    },
    formEleven: {
        files: [],
        saved: false,
    },
    formTwelve: {
        firstLineApproval: '',
        saved: false,
    },
    status: 'DRAFT',
};
// Reset the formData object in local storage
const resetForm = () => {
    saveStorage('formData', JSON.stringify(blankForm));
    return 'form reset';
};
// Save the current form
const saveFormStep = async (formName, data, requestedBy, id) => {
    try {
        // Make the api appropriate API request for the form being submitted
        const payload = { formData: { ...data }, requestedBy, id };
        const response = await httpClient.post(`/bff/starter/${formName}`, payload);
        const body = response.data.body;
        const item = body?.Item;
        if (item?.shortId) {
            saveStorage('shortId', item.shortId);
        }
        if (item?.docId) {
            saveStorage('atrId', item.docId);
        }
        saveStorage('visible', 'true');
        saveStorage('type', 'success');
        saveStorage('title', 'SAVED!');
        saveStorage('message', 'The form has been saved');
    }
    catch (_err) {
        saveStorage('visible', 'true');
        saveStorage('type', 'error');
        saveStorage('title', 'ERROR!');
        saveStorage('message', 'There was an error submitting the form.');
    }
};
const completeAtr = (payload) => {
    try {
        httpClient.post('/bff/starter/complete', payload);
        saveStorage('visible', 'true');
        saveStorage('type', 'success');
        saveStorage('title', 'SAVED!');
        saveStorage('message', 'Your ATR has been submitted');
    }
    catch (_err) {
        saveStorage('visible', 'true');
        saveStorage('type', 'error');
        saveStorage('title', 'ERROR!');
        saveStorage('message', 'There was an error submitting your ATR form.');
    }
};
const getChangedValues = (oldForm, newForm) => {
    const changedValues = [];
    // find any updated values
    for (const key of Object.keys(oldForm)) {
        const oldFormSection = oldForm[key];
        const newFormSection = newForm[key];
        if (!oldFormSection || !newFormSection)
            continue;
        for (const key2 of Object.keys(oldFormSection)) {
            const oldValue = oldFormSection &&
                typeof oldFormSection === 'object' &&
                key2 in oldFormSection
                ? oldFormSection[key2]
                : undefined;
            const newValue = newFormSection &&
                typeof newFormSection === 'object' &&
                key2 in newFormSection
                ? newFormSection[key2]
                : undefined;
            if (Array.isArray(oldValue) && !Array.isArray(newValue)) {
                changedValues.push({
                    [key]: {
                        [key2]: { old: oldValue, new: newValue },
                    },
                });
            }
            else if (key2.length > 3 &&
                oldValue !== newValue &&
                typeof oldValue === 'string' &&
                typeof newValue === 'string' &&
                oldValue.length &&
                newValue.length) {
                changedValues.push({
                    [key]: {
                        [key2]: { old: oldValue, new: newValue },
                    },
                });
            }
            else if (key2.length > 3 &&
                oldValue !== newValue &&
                Array.isArray(oldValue) &&
                Array.isArray(newValue)) {
                let changed = false;
                // array values changed
                if (oldValue.length !== newValue.length) {
                    changed = true;
                }
                else {
                    for (let i = 0; i < oldValue.length; i++) {
                        if (JSON.stringify(oldValue[i]) !== JSON.stringify(newValue[i])) {
                            changed = true;
                            break;
                        }
                    }
                }
                if (changed) {
                    changedValues.push({
                        [key]: {
                            [key2]: { old: oldValue, new: newValue },
                        },
                    });
                }
            }
            else if (key2.length > 3 &&
                oldValue !== newValue &&
                typeof oldValue !== 'object' &&
                typeof newValue !== 'object') {
                changedValues.push({
                    [key]: {
                        [key2]: { old: oldValue, new: newValue },
                    },
                });
            }
            else if (key2.length > 3 && !newValue && oldValue) {
                // fields removed
                changedValues.push({
                    [key]: {
                        [key2]: { old: oldValue, new: newValue },
                    },
                });
            }
        }
    }
    // any new fields added
    for (const key of Object.keys(newForm)) {
        const oldFormSection = oldForm[key];
        const newFormSection = newForm[key];
        if (!newFormSection)
            continue;
        for (const key2 of Object.keys(newFormSection)) {
            const oldValue = oldFormSection &&
                typeof oldFormSection === 'object' &&
                key2 in oldFormSection
                ? oldFormSection[key2]
                : undefined;
            const newValue = newFormSection &&
                typeof newFormSection === 'object' &&
                key2 in newFormSection
                ? newFormSection[key2]
                : undefined;
            if (key2.length > 3 && !oldValue && newValue) {
                changedValues.push({
                    [key]: {
                        [key2]: { old: oldValue, new: newValue },
                    },
                });
            }
        }
    }
    return changedValues;
};
export { resetForm, saveFormStep, completeAtr, getChangedValues };
